interface CompactPurchaseLayoutParams {
  platform: string
  userAgent: string | null
  viewportHeight: number
}

const IOS_VIEWPORT_HEIGHT_THRESHOLD = 760

export function isIosSafariUserAgent(userAgent: string | null): boolean {
  if (userAgent == null) {
    return false
  }

  const isIphone = /(iPhone|iPod)/i.test(userAgent)
  const isSafari =
    /Safari/i.test(userAgent) &&
    !/(CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|DuckDuckGo|YaBrowser)/i.test(userAgent)

  return isIphone && isSafari
}

export function isIosChromeUserAgent(userAgent: string | null): boolean {
  if (userAgent == null) {
    return false
  }

  const isIphone = /(iPhone|iPod)/i.test(userAgent)
  const isChrome = /CriOS/i.test(userAgent)

  return isIphone && isChrome
}

export function shouldUseCompactPurchaseLayout({
  platform,
  userAgent,
  viewportHeight,
}: CompactPurchaseLayoutParams): boolean {
  if (platform !== 'web') {
    return false
  }

  const isConstrainedBrowser =
    isIosSafariUserAgent(userAgent) || isIosChromeUserAgent(userAgent)

  if (!isConstrainedBrowser) {
    return false
  }

  return viewportHeight <= IOS_VIEWPORT_HEIGHT_THRESHOLD
}
